import {forwardRef, useState} from "react";

// eslint-disable-next-line no-restricted-imports -- TODO PG-6420: Remove this component once we've migrated to the new one
import {
    DeprecatedUsernameTextField,
    type CommonDeprecatedUsernameTextFieldProps,
} from "./deprecated-username-text-field.tsx";

type UncontrolledProps = CommonDeprecatedUsernameTextFieldProps & {
    /**
     * The initial input value.
     */
    initialValue?: string;
};

/**
 * @deprecated Use UncontrolledUsernameTextField instead.
 */
export const DeprecatedUncontrolledUsernameTextField = forwardRef<
    HTMLInputElement,
    UncontrolledProps
>((props, ref) => {
    const [value, setValue] = useState(props.initialValue || "");

    const handleChange = (newValue: string) => {
        setValue(newValue);
        props.onChange(newValue);
    };

    return (
        <DeprecatedUsernameTextField
            {...props}
            value={value}
            onChange={handleChange}
            ref={ref}
        />
    );
});
